import { render } from "./Style.md?vue&type=template&id=12ad9746"
const script = {}
script.render = render

export default script